import React from 'react';
import Box from '../lib_react_adminlte/componentes/Box.jsx';

/**
 * Configurações gerais da aplicação.
 */
export default class ConfigSenha extends React.Component {

  render() {
    const { checkbox, input, inputNumber } = this.props;
    return (
      <Box collapsible title="Configuração Senha" className="m-0">

        {/* Primeira coluna: */}
        <div className="col-sm-6 light-side-border">


        </div>

      </Box>
    );
  }

}




// WEBPACK FOOTER //
// ./src/componentes/ConfigSenha.jsx